import React from 'react';
import Games from '../domains/games/components/Games';

const GamesPage: React.FC = () => {
  return <Games />;
};

export default GamesPage; 